// extracted by mini-css-extract-plugin
export default {"container":"sL-z","topReviewHeading":"tL-z","criticalReview":"uL-z","favorableReview":"vL-z","vsSeparator":"wL-z"};